<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p><span dir="rtl">إلى روح لَم تُفارقني.. أبي - رحمه الله..</span></p>
<p><span dir="rtl">الغالية أمِّي - أطال الله بعمرها..</span></p>
<p><span dir="rtl">أخي محمد.. مُعيني ورفيق دَربي، ومُشجّعي في كلِّ خطواتي.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?4a2cb42c